export const modalsTypeSimulation = {
    equivalency: "equivalency",
    assets: "assets",
    provider: "provider",
};